export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4743.c1017256.jpg";